import React, { useCallback, useEffect, useRef } from 'react';
import * as styles from './index.module.less';

interface IProps {
  children?: React.ReactNode;
  isOpen?: boolean;
  onClose?: () => void;
  mask?: boolean;
  className?: string;
}

const Dialog = ({ children, isOpen = false, onClose, mask }: IProps) => {
  const dialogRef = useRef(null);

  const closeDialog = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    const dialogElement = dialogRef.current;
    if (isOpen) {
      dialogElement.showModal();
    } else {
      dialogElement.close();
    }

    // Optional: handle the Escape key to close the dialog
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        closeDialog();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [closeDialog, isOpen]);

  return (
    <>
      <dialog ref={dialogRef} className={styles.wrapper} data-custom-mask={mask ? 'mask' : 'no-mask'}>
        {children}
      </dialog>
    </>
  );
};

export default Dialog;
